import { ReportCategory } from "interface/ReportCategory";

/**
 * Test data array representing multiple report categories, each with metadata, description, and associated topics.
 *
 * @constant
 * @type {ReportCategory[]}
 * @default
 * 
 * @example
 * const zeroneReportCategories = [
 *   {
 *     id: "1aefd357-a6f2-4bf5-9910-e59be70bf99c",
 *     title: "Trending Topics",
 *     meta: {
 *       icon: "solar:graph-up-linear",
 *       primaryColor: "#C62E00",
 *       secondaryColor: "#FFEAE4"
 *     },
 *     description: "Brief overview of the category...",
 *     topics: [
 *       { id: "eadfa2f4-c477-42b9-bd85-6b2d2fd554bb", title: "The Power of AI", description: "This is a short description", dataset: "Dataset A", year: "2024" },
 *       { id: "05c1ba4d-552d-4dc1-bee0-eba6b68a7cc4", title: "TikTok Boom", description: "This is another short description", dataset: "Dataset B", year: "2024" }
 *     ]
 *   },
 *   // ...
 * ];
 */
export const zeroneReportCategories: ReportCategory[] = [
    {
        id: "9f0eeee2-d72c-40cd-a0c0-52572de54e3e",
        title: "Trending Topics",
        meta: {
            icon: "solar:graph-up-linear",
            primaryColor: "#C62E00",
            secondaryColor: "#FFEAE4"
        },
        description: "Find reports on emerging topics, trending innovation and new technologies. Delve into well curated content on topical issues and technologies pertaining to the African continent. Check out reports and insights on topics such as artificial intelligence, agriculture, digitization, fintech, robotics and many more.",
        shortDescription: "Authoritative reports on innovations shaping Africa.",
        topics: [
            {
                id: "d6c92e98-25a8-491a-aeb3-4dd247bd18e3",
                title: "AFRICA'S DIGITIZATION FOOTPRINT",
                description: 'Dive into our "State of Data In Africa" report and discover how the global digital revolution is playing out in the African context. This report contains an analysis of Africa’s data landscape, including the rise in data centers, government spending on digitization and private sector initiatives, among others. It discusses data gaps in African and opportunities available in the market for investors, entrepreneurs and other players.',
                dataset: "Markets, Industries & Sectors",
                year: "2024",
                meta: {
                    cover: 'https://firebasestorage.googleapis.com/v0/b/zeroneanalytics-55fec.appspot.com/o/reports%2FAFRICAS%20DIGITIZATION%20FOOTPRINT%2Fafrica-digitization.jpg?alt=media&token=b8581cbd-e77f-42a3-8ed6-a75d622b4622'
                },
                category: "",
                country: "Ghana"
            }
        ]
    },
    {
        id: "5d8c1e92-d309-4c0b-aa46-4f6bf9d41c7e",
        title: "Economic Indicators",
        meta: {
            icon: "streamline:politics-vote-2",
            primaryColor: "#9747FF",
            secondaryColor: "#F0E4FF"
        },
        description: "Discover comprehensive reports on many economies in Africa. Find out more about key economic and development indicators such as population, GDP, growth rates, demographics and more. Get access to nuanced statistics such as patent and copyright registrations per country, cellphone usage penetration and the interaction between women, the law and easy of business involvement.",
        shortDescription: "Key indicators and statistics on Africa’s economies.",
        topics: []
    },
    {
        id: "a5ba4967-62cd-4ffe-bc0f-4deb2d15c04b",
        title: "Agriculture",
        meta: {
            icon: "material-symbols-light:agriculture-outline",
            primaryColor: "#13757B",
            secondaryColor: "#D7FDFF"
        },
        description: "Our analysis and insights on agriculture captures several sub-industries and sectors. These include, agritech, core production, major imports & exports, agro-processing, agri-related ecosystems and agricultural inputs & machinery.",
        shortDescription: "Agriculture insights spanning technology, trade, and production ecosystems.",
        topics: []
    },
    {
        id: "a91089cd-ae7b-49d0-a99e-4bc84450139c",
        title: "Travel, Tourism & Hospitality",
        meta: {
            icon: "material-symbols-light:travel",
            primaryColor: "#009C4B",
            secondaryColor: "#D9FEEB"
        },
        description: "Dive into reports in the tourism & hospitality industry. Access careful curated insights and statistics hotels & resorts, short-term rentals, restaurants & food Services, adventure & sightseeing, transportation, real estate, immigration & permanent settlement.",
        shortDescription: "Coverage of travel, dining, lodging, and destination services.",
        topics: []
    },
    {
        id: "5bf3e874-32f7-4b9e-b2f5-eca1cee34133",
        title: "Retail & Consumer Goods",
        meta: {
            icon: "fluent:building-retail-20-regular",
            primaryColor: "#555863",
            secondaryColor: "#EBD1E4"
        },
        description: "We provide well researched and detailed reports into specific markets, products and companies of great significance to the retail & consumer goods industry. Find the latest on food & beverage, electronics & appliances, e-commerce, health & wellness, personal care & hygiene products, retail technologies & payment systems, baby products/toys, pet products & supplies, and so many more.",
        shortDescription: "Detailed reports on key markets and products in retail and consumer goods.",
        topics: []
    }
]